<table class="purchase-info">
    <tr *ngIf="code">
        <td class="key"> {{ 'LABEL.CODE' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data">{{ code + (referenceID ? ('-' + referenceID) : '') || ('LABEL.EMPTY' | translate) }}</td>
    </tr>
    <tr *ngIf="channel">
        <td class="key"> {{ 'LABEL.CHANNEL' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data channel">{{ channel }}</td>
    </tr>
    <tr>
        <td class="key"> {{ 'LABEL.TICKET_PASS' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data">{{ 'SYSTEM.' + passType | translate }}</td>
    </tr>
    <tr *ngIf="typeName">
        <td class="key"> {{ 'LABEL.TICKET_TYPE' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data">{{ getTicketType(numDay) | translate }}</td>
    </tr>
    <tr>
        <td class="key"> {{ 'LABEL.NUMBEROFTICKET' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data">{{ quantity || 1 }}</td>
    </tr>
    <tr *ngIf="totalPrice">
        <td class="key">{{ 'LABEL.TOTAL_PRICE' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data">{{ totalPrice | currency }}</td>
    </tr>
    <tr *ngIf="isPaid">
      <td class="key">{{ 'LABEL.PURCHASED_DATE' | translate }}</td>
      <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
      <!-- <td class="data">{{ orderDate ?  orderDate + ' ' + (_orderDate && _orderDate | date: 'hh:mm a') : (('LABEL.EMPTY' | translate)) }}</td> -->
      <td class="data">{{ orderDate ? setDateFormat(_orderDate) : (('LABEL.EMPTY' | translate)) }}</td>
    </tr>
    <tr *ngIf="isView">
        <td class="key">{{ 'LABEL.CREATE_DATE' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <!-- <td class="data">{{ createdDate ? createdDate + ' ' + (_createdDate && _createdDate | date: 'hh:mm a') : (('LABEL.EMPTY' | translate)) }}</td> -->
        <td class="data">{{ createdDate ? setDateFormat(_createdDate)  : (('LABEL.EMPTY' | translate)) }}</td>
    </tr>
    <tr *ngIf="paymentStatus">
      <td class="key">{{ 'LABEL.STATUS' | translate }}</td>
      <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
      <td class="data" [ngClass]="{
            'paid': isPaid && referenceID,
            'unpaid': paymentStatus == PAYMENT_STATUS.UNPAID,
            'in_payment': paymentStatus == PAYMENT_STATUS.IN_PAYMENT,
            'paid_re_submit': isPaid && !referenceID
        }">
        <!-- {{ 'PAGE.ORDER.HOME.LIST.' + (isPaid ? referenceID ? 'PAID' : 'PAID_RE_SUBMIT' : 'UNPAID') | translate }} -->

        <ng-container *ngIf="paymentStatus == PAYMENT_STATUS.PAID && referenceID">
                {{ 'PAGE.ORDER.HOME.LIST.PAID' | translate }}
            </ng-container>
            <ng-container *ngIf="paymentStatus == PAYMENT_STATUS.IN_PAYMENT">
                {{ 'PAGE.ORDER.HOME.LIST.IN_PAYMENT' | translate }}
            </ng-container>
            <ng-container *ngIf="paymentStatus == PAYMENT_STATUS.UNPAID">
                {{ 'PAGE.ORDER.HOME.LIST.UNPAID' | translate }}
            </ng-container>
            <ng-container *ngIf="isPaid && !referenceID">
                {{ 'PAGE.ORDER.HOME.LIST.PAID_RE_SUBMIT' | translate }}
            </ng-container>
        </td>
    </tr>

    <!-- <tr>
        <td class="key"><mat-icon svgIcon="date"></mat-icon> {{ 'LABEL.START_DATE' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data">{{ startdate }}</td>
    </tr>
    <tr>
        <td class="key"><mat-icon svgIcon="date"></mat-icon> {{ 'LABEL.EXPIRED_DATE' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data">{{ enddate }}</td>
    </tr>
    <tr *ngIf="isPaid">
        <td class="key"><mat-icon svgIcon="date"></mat-icon> {{ 'LABEL.PURCHASED_DATE' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data">{{ orderdate ? orderdate + ' ' + (_orderdate && _orderdate | date: 'hh:mm a') : (('LABEL.EMPTY' | translate)) }}</td>
    </tr>
    <tr *ngIf="paymentStatus">
        <td class="key"><mat-icon svgIcon="invoice"></mat-icon> {{ 'LABEL.STATUS' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data">{{ 'PAGE.ORDER.HOME.LIST.' + (isPaid ? referenceID ? 'PAID' : 'PAID_RE_SUBMIT' : 'UNPAID') | translate }}</td>
    </tr> -->
    <!-- <tr>
        <td class="key"><mat-icon svgIcon="invoice"></mat-icon> {{ 'LABEL.PICK_UP_TICKET' | translate }}</td>
        <td class="sign">{{ 'PUBLIC.SIGN' | translate }}</td>
        <td class="data">{{ 'LABEL.' + (isPickup ? 'PRINT_OPT' : 'DOWNLOAD_OPT') | translate }}</td>
    </tr> -->
</table>
